import React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import { GFInitialState, GFTeacherUser } from '../../models/models';

type Props = {
  teacher: GFTeacherUser;
  groupMembers: GFTeacherUser[];
}

const HeaderFilters: React.FC<Props> = ({ teacher, groupMembers }) => {
  const handleChange = (selected: any) => {
    browserHistory.push(`/performance-metrics/${selected.value}`);
  }

  const optionMapper = (t: GFTeacherUser) => ({ value: t.id, label: `${t.first} ${t.last}` });
  const value = optionMapper(teacher);
  const options = groupMembers.map(optionMapper);

  return <Row className="class-form">
    <Col xs={12}>
      <FormGroup bsSize="lg" className="class-lesson-selects">
        <Row>
          <Col xs={2}>
            <ControlLabel>Teacher</ControlLabel>
          </Col>
          <Col xs={8} className="class-row">
            <Select
              className="react-select-container"
              options={options}
              onChange={handleChange}
              value={value}
              placeholder="select teacher"
              classNamePrefix="react-select"
              isSearchable={false}
            />
          </Col>
        </Row>
      </FormGroup>
    </Col>
  </Row>;
};

const mapStateToProps = (state: GFInitialState, ownProps: any) => {
  return {
    groupMembers: state.groups.members,
  };
};

export default connect(mapStateToProps, {})(HeaderFilters);
